import { Box, Grid } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

import CustomReport from './CustomReport';
import OtherReports from './AllOtherReports/OtherReports';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Custom() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ padding: "10px" }}>
      <p style={{ coor: "#3E4A62", fontSize: "28px", fontWeight: "600", marginLeft: "20px" }}>Reports</p>
      <Box sx={{ borderColor: 'divider' }}>
        <Tabs sx={{ marginLeft: 3 }} value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Custom Report" {...a11yProps(0)} />
          <Tab label="Other Reports" {...a11yProps(1)} />


        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CustomReport />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <OtherReports />
      </TabPanel>


    </Box>

  )
}
